import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import ch from './locales/ch.json'

import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import 'dayjs/locale/en'

export const LocaleNameVariable = 'z_locale'
export const NormalizeLocale = (value) => {
  const locale = String(value || 'en').trim().toLowerCase()
  return ['zh', 'zh-cn', 'ch', 'cn'].includes(locale) ? 'zh-CN' : 'en'
}
// Define your translations
const messages = {
  en: en,
  'zh-CN': ch
}

let getLocale = NormalizeLocale(window.localStorage.getItem(LocaleNameVariable))
window.localStorage.setItem(LocaleNameVariable,getLocale)
document.documentElement.lang = getLocale

dayjs.locale(getLocale === 'zh-CN' ? 'zh-cn' : 'en')


// Create the i18n instance
const i18n = createI18n({
  locale: getLocale, // set locale
  fallbackLocale: 'en', // set fallback locale
  messages, // set locale messages
})


export default i18n
